import { Api, User } from "../../api.js";

export class UserCache {
    private cache = new Map<string, Promise<string>>();

    async getUserName(id: string): Promise<string> {
        if (!this.cache.has(id)) {
            this.cache.set(
                id,
                Api.getUser(id)
                    .then((user) => user.name)
                    .catch(() => `${id.slice(0, 7)}...`)
            );
        }
        return this.cache.get(id)!;
    }

    addUser(user: User) {
        if (!this.cache.has(user.id)) {
            this.cache.set(user.id, Promise.resolve(user.name));
        }
    }
}

export const userCache = new UserCache();
